import React, { useEffect, useState } from 'react';
import { View, ImageBackground, TouchableOpacity,  StyleSheet, TextInput as TextBox, TextInputChangeEventData, Platform, Dimensions, ScrollView, Pressable} from 'react-native';
import {MyButton} from './buttonsAndControls';
import { TextInput, Text, Provider as FirstTheme, IconButton, Modal, Portal } from 'react-native-paper';
import { DEBUG,enablePromise, openDatabase } from 'react-native-sqlite-storage';
import { useNavigation } from '@react-navigation/native';
import { branch, companyDir, getData, handleBranch, handleCompanyDir, header, headerText, stopCodes, stopExecutions } from './StockAwareTempData'
import Backdated from './DateTimeCheck';
import { getFirestore, collection, getDocs, query, where, doc, getDoc, deleteDoc } from "firebase/firestore";
import DateModule from './DateModule';
import DropDownPicker from 'react-native-dropdown-picker';
import Registration from './registration';

const darkColour = '#2a2d3e'

const theme = {
    roundness: 2,
    colors: {
      primary: '#2a2d3e',
      accent: '#2a2d3e',
      backdrop: 'rgba(0, 0, 0, 0.6)'
    },
  };

  interface Data {
    texts: string[];
  }

  interface EmployeeData {
    regID: string;
    firstname: string;
    middlename: string;
    lastname: string;
    phone: string;
    username: string;
    password: string;
    avarta: string;
    doe: string;
    dob: string;
    gender: string;
    address: string;
    appUser: boolean;
    salary: number;
  }

const LogIn= ()=>{

  if (stopCodes === undefined) {
    header('LogIn')
  }
  const computerDateTime = new Date();
  const [resultReceived, setResultReceived] = useState('');
  const [textUser, setTextUser] = useState('');
  const [textPass, setTextPass] = useState('');
  const navigation = useNavigation();
  const [showBackdated, setShowBackdated] = useState(true)
  const [result, setResult] = useState('');
  const [showlist, setshowlist] = useState(false)
  const [companyList, setCompanyList] = useState('')
  const [branchList, setBranchList] = useState<string[]>([]);
  const [iD, setID] = useState('');
  const [branchName, setBranchName] = useState('');
  const [branchAddress, setBranchAddress] = useState('');
  const [firstname, setFirstname] = useState('');
  const [middlename, setMiddlename] = useState('');
  const [lastname, setLastname] = useState('');
  const [phone, setPhone] = useState('');
  const [salary, setSalary] = useState('');
  const [address, setAddress] = useState('');
  const [isEditable, setIsEditable] = useState(true);
  const [birthDate, setBirthDate] = useState('')
  const [gender, setGender] = useState('')
  const [addNew, setAddNew] = useState(false)
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([
    {label: 'Male', value: 'Male', icon: () => <IconButton icon="human-male" iconColor= {darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />},
    {label: 'Female', value: 'Female', icon: () => <IconButton icon="human-female" iconColor= {darkColour} size={25} style={{width:34, height:34, padding:4}} containerColor='white' focusable={false} />}
  ]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [avatar, setAvatar] = useState('');
  const [showReg, setShowReg] = useState (false)


  const db = getFirestore();

  const readDataFromFirestore = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "companies"))
       querySnapshot.forEach((doc) => {
        setCompanyList((prev)=> prev + doc.data().name)
      });
    } catch (error) {
      console.error("Error reading data: ", error);
    }
    
  };

  const ListBranch = ({texts, onPressed, index, delPressed}: Data & { onPressed: () => void, index: number, delPressed: () => void}) => {
    const isEvenIndex = index % 2 === 0;
    const backgroundColor = isEvenIndex ? '#E6E6E6' : '#F5F5F5';
    const [hovered, setHovered] = useState(false);
    const [isOpacity, setIsOpacity] = useState(false);

    return (
      <TouchableOpacity style={{ backgroundColor }}>
        <Pressable style={{...styles.childTouchable,  
          backgroundColor: hovered ? '#CCCCCC' : 'transparent', 
          opacity: isOpacity ? 0.2 : 1 }}
          onHoverIn={() => setHovered(true)}
          onHoverOut={() => setHovered(false)}
          onPressIn={() => setIsOpacity(true)}
          onPressOut={() => setIsOpacity(false)}
          onPress={()=> onPressed()}
          >
          {texts.map((text, i) => (
            <View key={i} style={styles.childBoxes}>
              <Text key={i} style={styles.childText}>
                {text}
              </Text>
            </View>
          ))}
          {hovered && (
            <View style = {{width: 20, height: 20, alignSelf: 'center', justifyContent: 'center', alignContent: 'center'}}>
              <IconButton icon={'trash-can-outline'} size={25} focusable={true} iconColor={darkColour} 
                style={styles.iconButtonStyle}
                onPress={() => delPressed()}
                onHoverIn={() => setHovered(true)}
                onHoverOut={() => setHovered(false)}
              />
            </View>
          
          )}
        </Pressable>
      </TouchableOpacity>
    )
}
  
  // Call the function when needed
  // readDataFromFirestore();
  

  const handleUserInputChange = (text: string) => {
    setTextUser(text);
  }
  const handlePassInputChange = (text: string) => {
    setTextPass(text);
  }

  const handleBackdated = () => {
    setShowBackdated((prev) => !prev)
  }

  const CheckDateTime = async () => {
    DEBUG(true);
    enablePromise(true);
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    
    return new Promise(async (resolve, reject) => {
      try {
      (await initDB).transaction((tx) => {
        tx.executeSql(
          'CREATE TABLE IF NOT EXISTS StoredDateTime (ID INTEGER PRIMARY KEY, DateTime TEXT NOT NULL)',
          []
        );
        tx.executeSql('SELECT DateTime FROM StoredDateTime WHERE ID = ?', [1], (_, results) => {
          if (results.rows.length > 0) {
            const storedDateTime = new Date(results.rows.item(0).DateTime);
           
            if (storedDateTime > computerDateTime) {
              setResultReceived('Backdated')
              resolve(results); // Resolve the promise with the existing results
              
            } else  if (storedDateTime < computerDateTime) {
              tx.executeSql('UPDATE StoredDateTime SET DateTime = ? WHERE ID = ?', [computerDateTime.toISOString(), 1], (_, updateResults) => {
                // if (updateResults.rowsAffected > 0) {
                   setResultReceived('All good')
                // }
                resolve(updateResults); // Resolve the promise when the update is completed
              });
            }
          } else {
            tx.executeSql('INSERT INTO StoredDateTime (ID, DateTime) VALUES (?, ?)', [1, computerDateTime.toISOString()], (_, insertResults) => {
              // if (insertResults.rowsAffected > 0) {
                 setResultReceived('First time')
              // }
              resolve(insertResults); // Resolve the promise when the insertion is completed
            });
          }
        });
      });
    } catch (Error:any) {
      setResultReceived ('Error')
      reject(Error)
      console.log(Error)
    }
    }); 
  };
   
  // const handleLogIn = async () => {
  //   try {
  //     // Wait for the CheckDateTime function to complete
  //     await CheckDateTime();
  
  //     // Show or hide the modal based on the resultReceived
  //     if (resultReceived === 'Backdated') {
  //       setShowBackdated(true);
  //     } else {
  //       setShowBackdated(false);
  //     }
  
  //     setResult('');
  
  //     DEBUG(true);
  //     enablePromise(true);
  //     const initDB = await openDatabase({ name: 'StockAware.db', location: 'default' });
  //     await initDB.transaction((tx) => {
  //       tx.executeSql(
  //         'SELECT * FROM Registration WHERE Username = ? AND Password = ?',
  //         [textUser.toLowerCase(), textPass],
  //         (_, results) => {
  //           if (resultReceived === 'Backdated') {
  //             setResult('ShowBackdated');
  //             console.log(result);
  //           } else if (resultReceived === '') {
  //             Alert.alert('Log in failed', 'Unable to log in at this time, try again.');
  //           } else {
  //             if (results.rows.length > 0) {
  //               const avatar = results.rows.item(0).Avatar;
  //               const first = results.rows.item(0).Firstname;
  //               const last = results.rows.item(0).Lastname;
  //               getData(avatar, first, last);
  //               stopExecutions(false);
  //               navigation.navigate('Dashboard' as never);
  //             } else {
  //               // Invalid credentials
  //               Alert.alert('Log in failed', 'Invalid username or password');
  //             }
  //           }
  //         },
  //         (error) => {
  //           // Handle query error here
  //           console.error('Error executing SQL', error);
  //         }
  //       );
  //     });
  //   } catch (error) {
  //     // Handle any errors from CheckDateTime or other async functions here
  //     console.error('Error during login process', error);
  //     Alert.alert('Log in failed', 'An error occurred during the login process. Please try again.');
  //   }
  // };  

  const handleLogIn = async() => {
//     const result = window.confirm("Are you sure you want to delete this item?");
// if (result) {
//   // User clicked OK
// } else {
//   // User clicked Cancel
// }

// const userInput = window.prompt("Please enter your name:", "John Doe");
// if (userInput !== null) {
//   // User provided input (or Cancel was not clicked)
// } else {
//   // User clicked Cancel
// }


//

    
    stopExecutions(false);
    //navigation.navigate('NewSales' as never);
    //setshowlist(true)
    const myCollection = collection(getFirestore(), 'users');
    const q = query(myCollection, where('username', '==', textUser ), where('password', '==', textPass))
    getDocs(q)
      .then(async (querySnapshot) => {
        if (!querySnapshot.empty) {
          handleCompanyDir(querySnapshot.docs[0].data().company)
          handleBranch(querySnapshot.docs[0].data().branch)
          const avatar = querySnapshot.docs[0].data().avarta;
          const first = querySnapshot.docs[0].data().firstname;
          const last = querySnapshot.docs[0].data().lastname;
          getData(avatar, first, last);
          if (companyList.toLocaleLowerCase().includes(querySnapshot.docs[0].id.toLocaleLowerCase().substring(4))) {  
              const branchQuerySnapshot = await getDocs(collection(db, companyDir))
              branchList.splice(0);
              branchQuerySnapshot.forEach((doc) => {
                branchList.push(doc.id)
              });
              setshowlist(true)
          } else {
            navigation.navigate('Dashboard' as never);
          }
        } else {
          console.log('Authentication failed');
        }
      })
      .catch((error) => {
        console.error('Error checking username and password:', error);
      });
  }

  const branchPressed = async(text: string) => {
    handleBranch(text);
    setshowlist(false)
    navigation.navigate('Dashboard' as never);
  }

  const handleDelete = async(text: string) => {
    const delDocRef = doc(getFirestore(), companyDir, text);
    const docSnapshot = await getDoc(delDocRef);
    if (docSnapshot.exists()) {
      const dialogResult = window.prompt(`You are about to delete ${text}, this is irreversible.\nAll records it holds will be deleted.\nEnter branch name to confirm deletion.`)
      if (dialogResult === text) {
      try {
        deleteDoc(delDocRef);
        setBranchList(branchList.filter((row)=> row !== text))
        window.confirm(`Deletion Successful.\n${text} has been deleted.`);
      
      } catch (error) {
        window.confirm(`Failed to delete this employee.`);
      }
      } else {
        window.confirm(`Deletion Failed.\nBranch name was not provided.`)
      }
    }
  }

  const handleAddNew = () => {
    setshowlist(false);
    setAddNew(true)
  }

  const handleFistname = (text: string) => {
    setFirstname(text)
  }

  const handleMiddlename = (text:string) => {
    setMiddlename(text)
  }

 const handleLastname = (text:string) => {
    setLastname(text)
  }

  const handlePhone = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setPhone(digitsOnly)
  }

  const handleSalary = (text:string) => {
    const digitsOnly = text.replace(/[^0-9]/g, '');
    setSalary(digitsOnly)
  }

  const handleAddress = (text:string) => {
    setAddress(text)
  }

  const handleBirthDate = (day: string, month: string, year: string) => {
    setBirthDate(year + '-' + month + '-' + day)
  }

  const handleBranchName = (text: string) => {
    setBranchName(text);
  }

  const handleBranchAddress = (text: string) => {
    setBranchAddress(text);
  }

  const handleNext = () => {
    setAddNew(false);
    setShowReg(true);
      
  }

  useEffect(() => {
    readDataFromFirestore()
  }, []);
   

  const logTableColumns = async (tableName: string) => {
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql(
        `PRAGMA table_info(${tableName})`,
        [],
        (_, result) => {
          const columns = result.rows.raw();
          console.log(`Columns of table ${tableName}:`);
          columns.forEach((column) => {
            console.log(`Name: ${column.name}, Type: ${column.type}`);
          });
        },
        (_, error) => {
          console.error('Error retrieving table columns:', error);
        }
      );
      tx.executeSql(`SELECT * FROM ${tableName}`, [], (_, results) => {
        if (results.rows.length > 0) {
          for (let i = 0; i < results.rows.length; i++) {
            const row = results.rows.item(i);
            console.log('Row:', row);
            // Do something with each row, if needed
          }
        } else {
          console.log('No rows found in the StoredDateTime table.');
        }

        // Resolve the promise with the results
      });
    });
  };

  const deleteTable = async (tableName: string) => {
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql(
        `DROP TABLE IF EXISTS ${tableName}`,
        [],
        (_, result) => {
          console.log(`Table ${tableName} deleted successfully.`);
        },
        (_, error) => {
          console.error(`Error deleting table ${tableName}:`, error);
        }
      );
    });
  }
//SELECT Type, SUM(Amount) AS Total FROM Expenses GROUP BY Type ORDER BY Type DESC LIMIT 3;

const expenses = async () => {
  const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
  (await initDB).transaction((tx) => {
    tx.executeSql(
      "SELECT Expenses_Type, SUM(Amount) AS Total FROM Expenses GROUP BY Expenses_Type ORDER BY Expenses_Type ASC LIMIT 3;",
      [],
      (_, result) => {
        if (result.rows.length > 0) {
          for (let i = 0; i < result.rows.length; i++) {
            console.log(`Expenses: ${result.rows.item(i).Expenses_Type}, Quantity: ${result.rows.item(i).Total}`);
          };
          // const row = result.rows.item(0);
          // const itemName = row.Expenses_Type;
          // const totalQuantity = row.Total;

          // console.log(`Expenses: ${itemName}, Quantity: ${totalQuantity}`);
        } else {
          console.log('No data found');
        }
      },
      (_, error) => {
        console.log('Error executing SQL', error);
      }
    );
  });
};

  const highestItem = async (itemName:string) => {
    const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    (await initDB).transaction((tx) => {
      tx.executeSql(
        "SELECT Board, SUM(Quantity) AS TotalQuantity " +
        "FROM Sales_Items" +
        " WHERE Date >= DATETIME('now', '-30 days') AND Date <= DATETIME('now') " +
        "GROUP BY Board " +
        "ORDER BY TotalQuantity DESC " +
        "LIMIT 1;",
        [],
        (_, result) => {
          if (result.rows.length > 0) {
            const row = result.rows.item(0);
            const itemName = row.Board;
            const totalQuantity = row.TotalQuantity;
  
            console.log(`Highest Selling Stock: ${itemName}, Quantity: ${totalQuantity}`);
          } else {
            console.log('No data found');
          }
        },
        (_, error) => {
          console.log('Error executing SQL', error);
        }
      );
    });
  };
  const [doOnce, setDoOnce] = useState(true);

  const addColumn = async () => {
    console.log(doOnce)
  
      const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
      (await initDB).transaction((tx) => {
        tx.executeSql(
          'ALTER TABLE Monthly_Data ADD COLUMN Date DATETIME', [], (_, re) => {}
        );
      });
      setDoOnce(false);
      console.log('Inside')
   
  };

  const dbAction = async() => {
    
  }
  // useEffect(() => {
  //   const handleCheckDateTime = async () => {
  //     await CheckDateTime();
  //   };
  //   handleCheckDateTime();
  // }, []); 
  
  const updateIsMobile = () => {
    setIsMobile(Dimensions.get('window').width <= 768); // Adjust the breakpoint as needed
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Initial check
    updateIsMobile();

    // Listen for window resize events and update `isMobile`
    Dimensions.addEventListener('change', updateIsMobile);

    // Clean up the event listener when the component unmounts
    return () => {
      Dimensions.addEventListener('change', updateIsMobile);
    };
  }, []);

  const styles = StyleSheet.create ({
    container: {
      flex: 1,
    },
    childTouchable: {
      flexDirection: 'row',
      alignItems: 'center',
      height: 35,
      flex: 1,
      borderColor: 'black',
      borderTopWidth: 2,
      borderBottomWidth: 2,
      marginTop: -2,
    },
    childBoxes: {
      borderColor: 'black', 
      height: 30, 
      width: '85%',
      alignItems: 'center', 
      borderTopWidth: 0, 
      borderBottomWidth: 0,
    },
    childText: {
      fontFamily: 'century gothic', 
      fontSize: 15, 
      fontWeight: 'normal',
      marginTop: 6,
      color: darkColour
    },
    desktopContent: {
      flexDirection: 'row',
      flex: 1,
    },
    mobileContent: {
      flexDirection: 'column',
    },
    backgroundImage: {
      flex: 1,
    },
    loginBox: {
      backgroundColor: 'white',
      flex: 1,
      flexDirection: 'column',
      padding: 20,
      alignItems: 'center',
    },
    logoText: {
      fontFamily: 'century gothic',
      fontWeight: '700',
      color: 'white',
      fontSize: 60,
      alignSelf: 'center',
    },
    logoDescription: {
      fontStyle: 'italic',
      color: 'white',
      fontFamily: 'century gothic',
      marginLeft: 18,
    },
    quote: {
      fontStyle: 'italic',
      color: darkColour,
      fontFamily: 'century gothic',
      marginTop: 20,
      maxWidth: isMobile ? 300 : 400,
      alignSelf: 'center',
    },
    author: {
      fontStyle: 'italic',
      color: darkColour,
      fontFamily: 'century gothic',
      marginTop: 10,
      width: isMobile ? 300 : 400,
      fontWeight: 'bold',
      alignSelf: 'center',
    },
    inputContainer: {
      marginTop: isMobile ? 70 : 100,
      alignItems: 'center',
    },
    input: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderWidth: 0,
      borderColor: 'white',
      height:60, 
      width:isMobile ? 230 : 330, 
      fontSize: 17,
      backgroundColor:'white'   
    },
    icon: {
      marginLeft: 10, 
      width:50, 
      height: 55, 
      borderRadius:10, 
      backgroundColor:'white'
    },
    inputMain: {
      margin:20, 
      marginTop:20, 
      backgroundColor: 'transparent', 
      width:isMobile ? 300 : 400,
      height:60, 
      borderRadius:10, 
      alignSelf:'center', 
      flexDirection:'row', 
      borderWidth: 2
    },
    forgotPassword: {
      alignSelf: 'flex-end',
      textDecorationLine: 'underline',
      color: darkColour,
      fontStyle: 'italic',
    },
    header: {
      alignSelf:'center', 
      width: isMobile ? 300 : 400, 
      height: isMobile ? 80 : 100, 
      backgroundColor: darkColour, 
      borderRadius: 15, 
      marginTop: 50
    },
    box: {
      backgroundColor:'white', 
      flex:1, 
      flexDirection:'column'
    },
    loginButton: {
      alignSelf: 'center',
      textDecorationLine: 'underline',
      color: darkColour,
      fontStyle: 'italic',
      marginTop: 50
    },
    branchModal: {
      width: 300, 
      height: 300, 
      paddingBottom: 5,
      backgroundColor:'white', 
      borderRadius:10, 
      borderWidth:2, 
      borderColor:'#DCE3E8',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf:'center',
      alignContent:'center'
    },
    branchListStyle: {
      width: 280, 
      height: 170, 
      backgroundColor:'white', 
      borderRadius:10, 
      borderWidth:2, 
      borderColor:'#DCE3E8',
      marginVertical:10,
      //margin: 10,
      alignContent:'center'
    },
    listHeader: {
      backgroundColor: darkColour,
      width: 300,
      height: 40, 
      marginTop: -2,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      justifyContent: 'center',
      alignItems: 'center'
    },
    headerText: {
      fontFamily: 'century gothic', 
      fontSize: 17, 
      fontWeight: 'bold',
      marginTop: 0,
      color: 'white'
    },
    iconButtonStyle: {
      justifyContent:'center', 
      padding:0, 
      margin:0, 
      marginLeft: -5, 
      alignContent:'center',
    },
    listContent: {
      width: '100%',
      height: 40,
      backgroundColor: 'white',
      justifyContent: 'center',
      alignContent: 'center'
    },
    editStyle: {
      borderTopRightRadius: 10, 
      borderBottomRightRadius: 10, 
      height: 40, 
      width: 350, 
      fontSize: 15, 
      fontFamily: 'century gothic', 
      padding: 11,
      paddingHorizontal: 5,
      flex: 1
    },
    birthDateText: {
      fontFamily:'century gothic', 
      color: 'white', 
      fontSize:16, 
      padding:10, 
      paddingLeft:10, 
      fontWeight:'normal'
    },
    dateTextContainer: {
      backgroundColor: darkColour, 
      width:110, 
      height:40,
      borderRadius: 10, 
      borderTopRightRadius:0,
      borderBottomRightRadius:0,
      borderWidth:1,
      borderRightWidth:0,
      borderColor: darkColour,
      marginRight: -25
    },
    row: {
      flexDirection: 'row'
    },
    smallBox: {
      borderWidth: 2,
      borderColor: '#DCE3E8',
      borderRadius: 10,
      width: 500,
      height: 40,
      backgroundColor: 'white',
      margin: 10,
      marginVertical: 3,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    editEmployee: {
      borderColor: '#DCE3E8',
      borderRadius: 10,
      width:540,
      height: 350,
      //backgroundColor: 'white',
      //margin: 10,
      marginVertical: 3,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginTop: 5,
      
    },
    companyText: {
      fontFamily:'century gothic', 
      fontSize:15, 
      fontWeight:'normal', 
      textAlign:'center',
      color: darkColour,
      marginHorizontal: 10,
    },
  });

  return(<View style={styles.container}>
    <View style={isMobile ? styles.mobileContent : styles.desktopContent}>
      {!isMobile && 
      <View style = {{flex:2}}>
        <ImageBackground
          source={require('./src_Files/firstBackground.jpg')}
          style={styles.backgroundImage}
          resizeMode='cover'
        />
      </View>}
      <View style={styles.loginBox}>
        <View style={styles.header}>
          <Text style={{alignSelf:'center', fontFamily:'century gothic', fontWeight:'700', color:'white', fontSize: isMobile ? 45 : 60,}}>
              Stock Aware
          </Text>
          <Text style={{fontStyle:'italic', color:'white', fontFamily:'century gothic', marginLeft: 18}}>
              ...the ultimate business solution
          </Text>
        </View>
        <Text style={styles.quote}>
          Success in business requires training, discipline, and hard work.
          But if you're not frightened by these things, the opportunities are just as great today as they ever were.
        </Text>
        <Text style={styles.author}>- David Rockefeller</Text>
        <View style={styles.inputContainer}>
          <View style={styles.inputMain}>
            <View style={styles.icon}>
              <IconButton icon="account" iconColor={darkColour} containerColor='white' focusable={false} />
            </View>
            <TextInput
              style={styles.input}
              placeholder='Enter username'
              label={'Username'}
              value={textUser}
              spellCheck={false}
              textColor= 'black'
              onChangeText={handleUserInputChange}
            />
          </View>
          <View style={styles.inputMain}>
            <View style={styles.icon}>
              <IconButton icon="lock" iconColor={darkColour} containerColor='white' focusable={false} />
            </View>
            <TextInput
              style={styles.input}
              placeholder='Enter password'
              label={'Password'}
              value={textPass}
              spellCheck={false}
              textColor= 'black'
              secureTextEntry
              onChangeText={handlePassInputChange}
            />
          </View>
          <View style={{width: isMobile ? 300 : 400}}>
            <TouchableOpacity style={{ alignSelf:'flex-end'}} onPress={ ()=> dbAction()}>
                <Text style={styles.forgotPassword} >
                  Forgot password?
                </Text>
            </TouchableOpacity>
          </View>
        </View>
        <TouchableOpacity style={styles.loginButton} onPress={handleLogIn}>
          <View >
            <MyButton btnText='Login' btnColor= {darkColour} hndClicked={handleLogIn}/>
          </View>
        </TouchableOpacity>
        {result === 'ShowBackdated' && <Backdated onClicked={handleBackdated} backdated={showBackdated} />}
        <Portal>
          <Modal visible = {showlist} onDismiss={()=>setshowlist(false)} contentContainerStyle = {styles.branchModal}>
            <View style = {styles.listHeader}>
              <Text style = {styles.headerText}>
                Select a branch
              </Text>
            </View>
            <ScrollView style = {styles.branchListStyle}>
              {branchList.map((data, index) => (
                <ListBranch
                  key={data}
                  index={index}
                  texts={[data]}
                  onPressed={()=>{branchPressed(data)}}
                  delPressed={()=>{handleDelete(data)}}
                />
              ))}
            </ScrollView>
            <MyButton btnText='Add New Branch' btnWidth={180} hndClicked={()=> {handleAddNew()}}/>
          </Modal>
        </Portal>

        <Portal>
          <Modal visible = {addNew} onDismiss={()=>setAddNew(false)} contentContainerStyle = {{...styles.branchModal, width:540, height:550}}>
            <View>
              <Text style = {{...styles.headerText, color: darkColour}}>
                Branch Details
              </Text>
            </View>
            <View style = {{... styles.editEmployee, height: 120}}>
              <View style = {styles.smallBox}>
                <Text style = { styles.companyText}>
                  Branch Name:
                </Text>
                <TextBox style = {styles.editStyle} value= {branchName} onChangeText={handleBranchName} editable = {isEditable} />
              </View>

              <View style = {{...styles.smallBox, height: 60}}>
                <Text style = {{...styles.companyText, alignSelf: 'flex-start', marginTop: 5 }}>
                  Branch Address:
                </Text>
                <TextBox style = {{...styles.editStyle, flexWrap: 'wrap', height: '100%'}} 
                  numberOfLines={3} multiline value= {branchAddress} onChangeText={handleBranchAddress} editable = {isEditable} autoCapitalize="sentences" spellCheck = {false}
                />
              </View>
            </View>
            <View>
              <Text style = {{...styles.headerText, color: darkColour}}>
                Employee Details
              </Text>
            </View>
            <View style = { styles.editEmployee}>
              <View style = {styles.smallBox}>
                <Text style = { styles.companyText}>
                  First Name:
                </Text>
                <TextBox style = {styles.editStyle} value= {firstname} onChangeText={handleFistname} editable = {isEditable} />
              </View>

              <View style = {styles.smallBox}>
                <Text style = {styles.companyText}>
                  Middle Name:
                </Text>
                <TextBox style = {styles.editStyle} value= {middlename} onChangeText={handleMiddlename} editable = {isEditable} />
              </View>

              <View style = {styles.smallBox}>
                <Text style = { styles.companyText}>
                  Last Name:
                </Text>
                <TextBox style = {styles.editStyle} value= {lastname} onChangeText={handleLastname} editable = {isEditable} />
              </View>
            
              <View style = {styles.row}>
                <View style = {{...styles.smallBox, width: 260}}>
                  <Text style = { styles.companyText}>
                    Phone:
                  </Text>
                  <TextBox style = {styles.editStyle} value= {phone} onChangeText={handlePhone} editable = {isEditable} />
                </View>
                <View style = {{...styles.smallBox, width: 220}}>
                  <Text style = {styles.companyText}>
                    Salary (₦):
                  </Text>
                  <TextBox style = {{...styles.editStyle, width: 100}} value= {salary} onChangeText={handleSalary} editable = {isEditable} />
                </View>
              </View>

              <View style = {{...styles.smallBox, height: 60}}>
                <Text style = {{...styles.companyText, alignSelf: 'flex-start', marginTop: 5 }}>
                  Address:
                </Text>
                <TextBox style = {{...styles.editStyle, flexWrap: 'wrap', height: '100%'}} 
                  numberOfLines={3} multiline value= {address} onChangeText={handleAddress} editable = {isEditable} autoCapitalize="characters" spellCheck = {false}
                />
              </View>
              <View style = {{...styles.row, width: 500, marginHorizontal: 10}}>
                <View style={{ flexDirection:'row', marginTop: 4}}>
                  <View style={{...styles.dateTextContainer, borderColor: darkColour}}>
                    <Text style={{...styles.birthDateText, color: 'white'}}>Birth Date</Text>
                  </View>
                  <DateModule 
                    appearUp = {true} 
                    dateReset = {isEditable} 
                    onNewDateSelected= {handleBirthDate} 
                    _day= {birthDate ? birthDate.split('-')[2] : undefined} 
                    _month= {birthDate ? birthDate.split('-')[1] : undefined} 
                    _year= {birthDate ? birthDate.split('-')[0] : undefined}
                  />
                  <View style = {{marginLeft: 15}}>
                    <View style={{width:200, height:40}}>
                      <DropDownPicker
                        theme="DARK"
                        modalAnimationType='slide'
                        placeholder='Gender'
                        dropDownDirection='TOP'
                        style={{borderRadius:10, borderWidth:1, height: 40, borderColor: darkColour}}
                        open={open}
                        value={gender}
                        items={items}
                        setOpen={setOpen}
                        setValue={setGender}
                        setItems={setItems}
                        listItemContainerStyle={{backgroundColor:'white'}}
                        listItemLabelStyle={{color:'black', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
                        textStyle={{color:'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300'}}
                        placeholderStyle={{color: 'white', fontFamily:'century gothic', fontSize:16, fontWeight:'300', textAlign:'center'}}
                      />
                    </View>
                  </View>
                  
                </View>          
              </View>
              <View style = {{...styles.row, width: 500, marginBottom: 5, justifyContent: 'flex-end'}}>
                <View style = {{marginTop: 10}}>
                  <MyButton btnText= "Next >>"
                    btnBorClr= 'white'
                    btnBorRadius={10}
                    btnColor= {darkColour}
                    btnFontSize={15}
                    btnHeight={40}
                    btnWidth={100}
                    btnTxtClr={'white'}
                    btnPadding={10}
                    hndClicked={()=> {handleNext()}}
                  />
                </View>
              </View>
            </View>
          </Modal>
        </Portal>
        {showReg &&
          <Registration _regID= {iD} _firstname= {firstname} _middlename= {middlename} _lastname= {lastname} _birthDate= {birthDate} _newBranch= {true}
          _username= {username} _password= {password} _avatar= {avatar} _gender= {gender} _phone= {phone} _salary= {salary} showModal = {showReg}
          _address= {address}  onClicked={()=> {setShowReg(false)}} isEdit = {false} _branchName= {branchName} _branchAddress= {branchAddress}
        />
        }
      </View>
    </View>
  </View>
);

  }

  /*









  return(
    <View style={styles.container}>
      <View style={isMobile ? styles.mobileContent : styles.desktopContent}>
        <ImageBackground
          source={require('./src_Files/firstBackground.jpg')}
          style={styles.backgroundImage}
          resizeMode='cover'
        />
      </View>
      <View style={styles.box} >
        <View style={styles.header}>
            <Text style={{alignSelf:'center', fontFamily:'century gothic', fontWeight:'700', color:'white', fontSize: 60,}}>
                Stock Aware
            </Text>
            <Text style={{fontStyle:'italic', color:'white', fontFamily:'century gothic', marginLeft: 18}}>
                ...the ultimate business solution
            </Text>
        </View>
        <Text style={styles.quote}>
          Success in business requires training, discipline, 
          and hard work. But if you're not frightened by these 
          things, the opportunities are just as great today as 
          they ever were. 
        </Text>
        <Text style={{fontStyle:'italic', color: darkColour, fontFamily:'century gothic', fontWeight:'bold', marginLeft:77, maxWidth:400, alignSelf:'flex-start'}}>
        - David Rockefeller
        </Text>

        <View style={{marginTop:100, backgroundColor:'white', alignItems:'center',}}>
        <Text style={{alignSelf:'center', fontFamily:'century gothic', fontWeight:'normal', color: darkColour, fontSize: 25,}}>
            Login credentials
        </Text>
          <View style={styles.inputMain}>
            <View style={styles.icon}>
              <IconButton icon="account" iconColor={darkColour} containerColor='white' focusable={false} />
            </View>
            <TextInput
              style={styles.input}
              placeholder='Enter username'
              label={'Username'}
              value={textUser}
              spellCheck={false}
              textColor= 'black'
              onChangeText={handleUserInputChange}
              
            />
          </View>
          <View style={styles.inputMain}>
            <View style={styles.icon}>
              <IconButton icon="lock" iconColor={darkColour} containerColor='white' focusable={false} />
            </View>
            <TextInput
              style={styles.input}
              placeholder='Enter password'
              label={'Password'}
              value={textPass}
              spellCheck={false}
              textColor= 'black'
              secureTextEntry
              onChangeText={handlePassInputChange}
            />
          </View>
          <View style={{width:400}}>
            <TouchableOpacity style={{ alignSelf:'flex-end'}} onPress={ ()=> dbAction()}>
                <Text style={styles.forgotPassword} >
                  Forgot password?
                </Text>
            </TouchableOpacity>
          </View>
          
          
        </View>
        <View style={{ paddingLeft:0, backgroundColor:'transparent', marginTop:20, alignItems:'center'}}>
            <View>
                <MyButton btnText='Login' btnColor= {darkColour} hndClicked={handleLogIn}/>
            </View>
           {result === 'ShowBackdated' && (
            <Backdated onClicked={handleBackdated} backdated={showBackdated} />
           )}
           
        </View>
      </View>  
    </View>
);

*/




export default LogIn